<div class="container" fxLayout="column">
    <card-box [title]="'Relatório Líquido'" fxFlex>
        <div class="chart-container" style="position: relative; width: 98%; height: 300px;">
            <canvas id="canvas">{{chart}}</canvas>
        </div>
    </card-box>
</div>